import { GetApproachTableNameParams } from './types';

export const getTableName = (tableName: string) => tableName.replaceAll(/[^\w]/g, '')?.replace(/^\d/, '_$&')

const getApproachTableName = (params: GetApproachTableNameParams) => {
  const { approach, tableSuffix = '' } = params;
  const updatedName = getTableName(approach?.name ?? '') // Ensure approach name is defined before processing

  return [
    updatedName,
    approach?.id ?? approach?.panelId?.replaceAll(/-/g, '_'),
    tableSuffix.length ? tableSuffix.toUpperCase() : false,
  ]
    .filter(Boolean)
    .join('_');
};

export default getApproachTableName;
